//          Image
export { default as Boy } from "./image/boy.jpg";
export { default as avatar } from "./image/avatar.png";
export { default as noImage } from "./image/noImage.jpg";
export { default as ellips } from "./image/ellips.png";
export { default as Logo } from "./icon/teacher.svg";
export {default as Corner} from './icon/corner.svg';
export {default as arrow} from './icon/arrow.svg';
export {default as globe} from './icon/globe.svg';
export {default as repair} from './icon/repair.svg';
export {default as fastEmail} from './icon/fastEmail.svg';
export {default as verMessage} from './icon/verMessage.svg';
export {default as shield} from './icon/shield.svg';
export {default as phone} from './icon/phone.svg';
export {default as addimage} from './icon/addimage.svg';
export {default as file} from './icon/file.svg';
export {default as PDF} from './icon/PDF.svg';
export {default as download} from './icon/download.svg';
export {default as downloaded} from './icon/downloaded.svg';
export {default as player} from './icon/player.svg';
export {default as galochka} from './icon/galochka.svg';
export {default as closeModal} from './icon/closeModal.svg';
export {default as uploadFile} from './icon/uploadFile.svg';
export {default as successUpload} from './icon/successUpload.svg';
export {default as telegram} from './icon/telegram.svg';
export {default as instagram} from './icon/instagram.svg';
export {default as facebook} from './icon/facebook.svg';
export {default as vectorPrev} from './icon/vectorPrev.svg';
export {default as searchs} from './icon/search.svg';
export {default as chemistry} from './image/chemistry.jpg';
export {default as angelRight} from './icon/angleRight.svg';
export {default as videoIcon} from './icon/videoIcon.svg';
export {default as likeVideo} from './icon/likeVideo.svg';
export {default as crypto} from './icon/crypto.svg';
export {default as commentDots} from './icon/commentDots.svg';
export {default as notification} from './icon/notification.svg';
export {default as bell} from './icon/bell.svg';
export {default as message} from './icon/message.svg';
export {default as maths} from './icon/math.svg';
export {default as saved} from './icon/saved.svg';
export {default as rating} from './icon/rating.svg';
export {default as homeFilled} from './icon/homeFilled.svg';
export {default as publicateActive} from './icon/publicateActive.svg';
export {default as lock} from './icon/lock.svg';
export {default as lockOpen} from './icon/lockOpen.svg';
export {default as pen} from './icon/pen.svg';
export {default as usersIcon} from './icon/user-avatar.svg';
export {default as logout} from './icon/logout.svg';
export {default as admin} from './icon/admin.svg';
export {default as group} from './icon/group.svg';
export {default as arrowLeft} from './icon/arrowLeft.svg';
export {default as trash} from './icon/trash.svg';
export {default as plusCircle} from './icon/plus-circle.svg';
export {default as imagePlus} from './icon/imagePlus.svg';
export {default as starLine} from './icon/starLine.svg';
export {default as qalpoq} from './icon/qalpoq.svg';
export {default as Present} from './icon/Present.svg';
export {default as plus} from './icon/plus.svg';
export {default as circleCheckbox} from './icon/circleCheckbox.svg';
export {default as circle} from './icon/circle.svg';
export {default as dotss} from './icon/dots.svg';
export {default as messageme} from './icon/messageme.svg';
export {default as messageyou} from './icon/messageyou.svg';

//          Icon
export const play = {
  play: (
    <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
<g id="Voice Play">
<circle id="Ellipse 851" cx="18" cy="18" r="18" fill="#5790DF"/>
<g id="&#240;&#159;&#166;&#134; icon &#34;google-play&#34;">
<path id="Vector" d="M20.9334 18.7132L22.9317 20.6972L25.8724 18.9987C26.2656 18.802 26.5174 18.4036 26.5263 17.964C26.5104 17.5388 26.26 17.1575 25.8762 16.974C25.6319 16.842 23.5374 15.6267 22.7515 15.1693L22.7492 15.1677L13.2295 9.6716C12.8403 9.4253 12.3487 9.40762 11.9429 9.62532C11.9041 9.65165 11.8671 9.6804 11.832 9.71142L20.9334 18.7132Z" fill="white"/>
<path id="Vector_2" d="M25.8755 16.9737C25.6469 16.8502 23.8112 15.7855 22.9306 15.2734L20.9135 17.276L11.7891 26.3282C11.8263 26.3622 11.8661 26.3933 11.908 26.4213C12.0703 26.5143 12.2543 26.5627 12.4413 26.5617C12.6683 26.5588 12.8907 26.4966 13.0861 26.3811C13.3881 26.2059 22.7485 20.8024 22.7485 20.8024L25.8717 18.9984C26.2649 18.8018 26.5167 18.4033 26.5256 17.9637C26.5097 17.5385 26.2593 17.1572 25.8755 16.9737Z" fill="white"/>
<path id="Vector_3" d="M20.1981 17.9865L11.8331 9.71289C11.5336 9.94464 11.3537 10.3012 11.3691 10.6852V25.4333C11.359 25.7847 11.5217 26.11 11.7908 26.3273L20.1981 17.9865Z" fill="white"/>
<path id="Vector_4" d="M25.876 16.9737C25.2978 16.6623 23.2581 15.4637 22.9311 15.2734L20.914 17.276L20.1982 17.986L20.9332 18.7129L22.9315 20.6969L25.8722 18.9984C26.2654 18.8018 26.5173 18.4033 26.5261 17.9637C26.5102 17.5385 26.2598 17.1572 25.876 16.9737Z" fill="white"/>
</g>
</g>
</svg>

  ),
}
export const tutorIcons = {
  
  add: (
    <svg
      width="22"
      height="23"
      viewBox="0 0 22 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11 5.77969C11.2387 5.77969 11.4676 5.87513 11.6364 6.04501C11.8052 6.21488 11.9 6.44528 11.9 6.68553V10.9127H16.1C16.3387 10.9127 16.5676 11.0082 16.7364 11.1781C16.9052 11.3479 17 11.5783 17 11.8186C17 12.0588 16.9052 12.2892 16.7364 12.4591C16.5676 12.629 16.3387 12.7244 16.1 12.7244H11.9V16.9516C11.9 17.1919 11.8052 17.4223 11.6364 17.5921C11.4676 17.762 11.2387 17.8574 11 17.8574C10.7613 17.8574 10.5324 17.762 10.3636 17.5921C10.1948 17.4223 10.1 17.1919 10.1 16.9516V12.7244H5.9C5.66131 12.7244 5.43239 12.629 5.2636 12.4591C5.09482 12.2892 5 12.0588 5 11.8186C5 11.5783 5.09482 11.3479 5.2636 11.1781C5.43239 11.0082 5.66131 10.9127 5.9 10.9127H10.1V6.68553C10.1 6.44528 10.1948 6.21488 10.3636 6.04501C10.5324 5.87513 10.7613 5.77969 11 5.77969Z"
        fill="black"
      />
      <path
        d="M0 4.74526C0 3.68493 0.418501 2.66804 1.16344 1.91827C1.90837 1.16851 2.91872 0.747299 3.97222 0.747299H18.0278C19.0813 0.747299 20.0916 1.16851 20.8366 1.91827C21.5815 2.66804 22 3.68493 22 4.74526V18.8919C22 19.9522 21.5815 20.9691 20.8366 21.7189C20.0916 22.4686 19.0813 22.8898 18.0278 22.8898H3.97222C2.91872 22.8898 1.90837 22.4686 1.16344 21.7189C0.418501 20.9691 0 19.9522 0 18.8919V4.74526ZM3.97222 2.59251C3.40495 2.59251 2.86092 2.81932 2.4598 3.22304C2.05868 3.62676 1.83333 4.17431 1.83333 4.74526V18.8919C1.83333 20.0802 2.79156 21.0446 3.97222 21.0446H18.0278C18.595 21.0446 19.1391 20.8178 19.5402 20.4141C19.9413 20.0104 20.1667 19.4628 20.1667 18.8919V4.74526C20.1667 4.17431 19.9413 3.62676 19.5402 3.22304C19.1391 2.81932 18.595 2.59251 18.0278 2.59251H3.97222Z"
        fill="black"
      />
    </svg>
  ),
  home: (
    <svg
      width="22"
      height="24"
      viewBox="0 0 22 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.21779 22.0426L2.2089 22.0424H2.2C1.88607 22.0424 1.58227 21.9161 1.35617 21.687C1.12962 21.4574 1 21.1432 1 20.8129V10.5226L11 1.83625L21 10.5226V20.8129C21 21.1432 20.8704 21.4574 20.6438 21.687C20.4177 21.9161 20.1139 22.0424 19.8 22.0424H19.7911L19.7822 22.0426L15 22.1277V16.4552C15 15.603 14.6661 14.783 14.0674 14.1763C13.8611 13.9673 13.5972 13.8022 13.3708 13.6799C13.1293 13.5495 12.8605 13.4308 12.5959 13.3306C12.1053 13.145 11.4798 12.9666 11 12.9666C10.5202 12.9666 9.8947 13.145 9.40414 13.3306C9.13946 13.4308 8.87069 13.5495 8.6292 13.6799C8.40277 13.8022 8.13887 13.9673 7.93256 14.1763C7.33395 14.783 7 15.603 7 16.4552V22.1277L2.21779 22.0426Z"
        stroke="black"
        strokeWidth="2"
      />
    </svg>
  ),
  search: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.5714 19.2509C15.3053 19.2509 19.1429 15.3885 19.1429 10.6239C19.1429 5.85938 15.3053 1.99695 10.5714 1.99695C5.83756 1.99695 2 5.85938 2 10.6239C2 15.3885 5.83756 19.2509 10.5714 19.2509Z"
        stroke="black"
        strokeWidth="2.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17 17.0941L22 22.1266"
        stroke="black"
        strokeWidth="2.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  star: (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21.9631 8.73254C21.8937 8.53031 21.7675 8.35268 21.5999 8.22119C21.4322 8.0897 21.2302 8.01001 21.0184 7.99177L14.7679 7.07411L11.9667 1.35804C11.8768 1.17111 11.7363 1.01346 11.5615 0.903155C11.3866 0.792848 11.1844 0.734344 10.9781 0.734344C10.7717 0.734344 10.5695 0.792848 10.3946 0.903155C10.2198 1.01346 10.0793 1.17111 9.9894 1.35804L7.18821 7.06305L0.937716 7.99177C0.734408 8.02086 0.54327 8.10672 0.385993 8.23961C0.228715 8.3725 0.111597 8.5471 0.0479275 8.7436C-0.0103537 8.93561 -0.0155837 9.13998 0.0327986 9.33476C0.081181 9.52955 0.181349 9.70739 0.322554 9.84922L4.85938 14.2717L3.76087 20.5516C3.72166 20.7589 3.74219 20.9732 3.82005 21.1691C3.89791 21.365 4.02985 21.5344 4.20028 21.6573C4.36639 21.7768 4.56231 21.8473 4.76606 21.861C4.9698 21.8747 5.1733 21.8309 5.35371 21.7347L10.9781 18.7826L16.5804 21.7457C16.7346 21.8333 16.9087 21.879 17.0857 21.8784C17.3184 21.8792 17.5454 21.8057 17.7339 21.6683C17.9043 21.5454 18.0362 21.376 18.1141 21.1801C18.1919 20.9842 18.2125 20.77 18.1733 20.5627L17.0748 14.2828L21.6116 9.86027C21.7702 9.72503 21.8874 9.54728 21.9496 9.34765C22.0119 9.14803 22.0165 8.93473 21.9631 8.73254ZM15.2073 13.155C15.0785 13.2804 14.9821 13.4357 14.9266 13.6072C14.871 13.7787 14.858 13.9613 14.8887 14.139L15.6797 18.7716L11.5493 16.5603C11.3903 16.4752 11.213 16.4306 11.033 16.4306C10.8529 16.4306 10.6756 16.4752 10.5167 16.5603L6.3863 18.7716L7.17722 14.139C7.20791 13.9613 7.19492 13.7787 7.1394 13.6072C7.08387 13.4357 6.98749 13.2804 6.85866 13.155L3.56314 9.83816L8.18785 9.16373C8.36581 9.13882 8.53497 9.07035 8.68053 8.96434C8.82608 8.85832 8.94357 8.71799 9.02271 8.55564L10.9781 4.34322L13.0432 8.5667C13.1224 8.72904 13.2399 8.86937 13.3854 8.97539C13.531 9.08141 13.7001 9.14987 13.8781 9.17479L18.5028 9.84922L15.2073 13.155Z"
        fill="black"
      />
    </svg>
  ),
  user: (
    <svg
      width="22"
      height="24"
      viewBox="0 0 22 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11 0.740829C8.82441 0.740829 6.69767 1.39462 4.88873 2.61953C3.07979 3.84444 1.66989 5.58544 0.83733 7.62239C0.00476611 9.65934 -0.213071 11.9007 0.211367 14.0631C0.635804 16.2256 1.68345 18.2119 3.22183 19.7709C4.76021 21.3299 6.72022 22.3916 8.85401 22.8217C10.9878 23.2518 13.1995 23.0311 15.2095 22.1874C17.2195 21.3436 18.9375 19.9148 20.1462 18.0816C21.3549 16.2484 22 14.0931 22 11.8884C21.9967 8.93289 20.8367 6.09943 18.7745 4.00959C16.7123 1.91975 13.9164 0.744201 11 0.740829ZM6.28572 20.1511V19.0546C6.28634 18.4213 6.53488 17.8141 6.9768 17.3662C7.41871 16.9184 8.0179 16.6665 8.64286 16.6659H13.3571C13.9821 16.6665 14.5813 16.9184 15.0232 17.3662C15.4651 17.8141 15.7137 18.4213 15.7143 19.0546V20.1511C14.2836 20.9977 12.6567 21.4438 11 21.4438C9.34331 21.4438 7.71637 20.9977 6.28572 20.1511ZM17.2794 18.9957C17.2638 17.9513 16.8439 16.9549 16.1102 16.2212C15.3766 15.4876 14.3879 15.0753 13.3571 15.0734H8.64286C7.61215 15.0753 6.62345 15.4876 5.88979 16.2212C5.15613 16.9549 4.73623 17.9513 4.72058 18.9957C3.29573 17.7064 2.29094 16.0089 1.83923 14.128C1.38753 12.247 1.51023 10.2715 2.19108 8.46278C2.87193 6.6541 4.07882 5.09766 5.65194 3.99955C7.22506 2.90143 9.0902 2.31345 11.0004 2.31345C12.9106 2.31345 14.7757 2.90143 16.3489 3.99955C17.922 5.09766 19.1289 6.6541 19.8097 8.46278C20.4906 10.2715 20.6133 12.247 20.1616 14.128C19.7099 16.0089 18.7043 17.7064 17.2794 18.9957Z"
        fill="black"
      />
      <path
        d="M14.9642 9.68929C14.9642 11.9001 13.1848 13.6841 10.9999 13.6841C8.81507 13.6841 7.03564 11.9001 7.03564 9.68929C7.03564 7.47843 8.81507 5.69446 10.9999 5.69446C13.1848 5.69446 14.9642 7.47843 14.9642 9.68929Z"
        stroke="black"
        strokeWidth="1.5"
      />
    </svg>
  ),
  arrow: (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.38561 12.4852L19.5273 12.4852"
        stroke="black"
        strokeWidth="1.51417"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.4922 18.5671L4.38502 12.4862L10.4922 6.4043"
        stroke="black"
        strokeWidth="1.51417"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  dots: (
    <svg
      width="4"
      height="16"
      viewBox="0 0 4 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2 1.25C2.41421 1.25 2.75 1.58579 2.75 2C2.75 2.41421 2.41421 2.75 2 2.75C1.58579 2.75 1.25 2.41421 1.25 2C1.25 1.58579 1.58579 1.25 2 1.25ZM2 7.25C2.41421 7.25 2.75 7.58579 2.75 8C2.75 8.41421 2.41421 8.75 2 8.75C1.58579 8.75 1.25 8.41421 1.25 8C1.25 7.58579 1.58579 7.25 2 7.25ZM2 13.25C2.41421 13.25 2.75 13.5858 2.75 14C2.75 14.4142 2.41421 14.75 2 14.75C1.58579 14.75 1.25 14.4142 1.25 14C1.25 13.5858 1.58579 13.25 2 13.25Z"
        fill="black"
        stroke="black"
        strokeWidth="1.5"
      />
    </svg>
  ),
  
  admin: (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="User">
        <path
          id="Vector"
          d="M5.68406 7.57113C7.21011 7.57113 8.44721 6.38826 8.44721 4.92912C8.44721 3.46998 7.21011 2.28711 5.68406 2.28711C4.15801 2.28711 2.9209 3.46998 2.9209 4.92912C2.9209 6.38826 4.15801 7.57113 5.68406 7.57113Z"
          stroke="black"
          strokeMiterlimit="10"
        />
        <path
          id="Vector_2"
          d="M1.33789 9.69418C1.76254 8.99139 2.37313 8.40783 3.10833 8.00211C3.84354 7.59639 4.67746 7.3828 5.52633 7.38281C6.37519 7.38282 7.20911 7.59642 7.9443 8.00215C8.6795 8.40789 9.29008 8.99147 9.71471 9.69427"
          stroke="black"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  ),
  userAvatar: (
    <svg
      width="35"
      height="35"
      viewBox="0 0 35 35"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="17.5" cy="17.5" r="17.5" fill="#F5F5F5" />
      <path
        d="M17.5003 19.6875C20.722 19.6875 23.3337 17.2064 23.3337 14.1459C23.3337 11.0853 20.722 8.60419 17.5003 8.60419C14.2787 8.60419 11.667 11.0853 11.667 14.1459C11.667 17.2064 14.2787 19.6875 17.5003 19.6875Z"
        stroke="black"
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M8.6582 24.5356C9.55468 23.0615 10.8437 21.8375 12.3958 20.9865C13.9479 20.1355 15.7084 19.6875 17.5005 19.6875C19.2925 19.6875 21.053 20.1355 22.6051 20.9866C24.1572 21.8376 25.4462 23.0617 26.3426 24.5358"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
};
